<script>
import CrudList from 'Support/components/crud/CrudList.vue';
import CustomerRequest from 'Domain/customers/CustomerRequest';
import DataTableCpfCnpjColumn from 'Support/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableTextColumn from 'Support/components/data-table/DataTableColumns/DataTableTextColumn.vue';
import CustomersStatusDataTableColumn from 'App/customers/CustomersStatusDataTableColumn.vue';
import DataTableDateOnlyColumn from 'Support/components/data-table/DataTableColumns/DataTableDateOnlyColumn.vue';
import DataTableNumberColumnVue from 'Support/components/data-table/DataTableColumns/DataTableNumberColumn.vue';
import CustomerEditProrrogacaoModalColumnVue from './components/CustomerEditProrrogacaoModalColumn.vue';

export default {
  name: 'CustomersCrudList',
  extends: CrudList,
  data() {
    return {
      headers: [
        {
          text: this.$t('app.customers.list.headers.situation'),
          value: 'status',
          component: CustomersStatusDataTableColumn,
          width: '1%',
          align: 'center',
        },
        {
          text: this.$t('app.customers.list.headers.companyName'),
          value: 'nomeFantasia',
        },
        {
          text: this.$t('app.customers.list.headers.clienteIdSgv'),
          value: 'clienteIdSgv',
          align: 'right',
          orderBy: 'informacaoTendencia.tendenciaClienteId',
        },
        {
          text: this.$t('app.customers.list.headers.document'),
          value: 'cpfCnpj',
          component: DataTableCpfCnpjColumn,
        },
        {
          text: this.$t('app.customers.list.headers.email'),
          value: 'email',
        },
        {
          text: this.$t('app.customers.list.headers.empresa'),
          value: 'nomeEmpresa',
        },
        {
          text: this.$t('app.customers.list.headers.cidade'),
          value: 'nomeCidade',
        },
        {
          text: this.$t('app.customers.list.headers.datCadastro'),
          value: 'datCadastro',
          component: DataTableDateOnlyColumn,
          align: 'center',
          orderBy: 'criadoEm',
        },
        {
          text: this.$t('app.customers.list.headers.scoreSgv'),
          value: 'scoreSGV',
          align: 'center',
          component: DataTableTextColumn,
        },
        {
          text: this.$t('app.customers.list.headers.datPrimeiraContratacaoProrrogacao'),
          value: 'datPrimeiraContratacaoProrrogacao',
          align: 'center',
          component: DataTableDateOnlyColumn,
        },
        {
          text: this.$t('app.customers.list.headers.qtdContratacaoProrrogacao'),
          value: 'qtdContratacaoProrrogacao',
          align: 'center',
          component: DataTableNumberColumnVue,
        },
        {
          text: this.$t('app.customers.list.headers.datPrimeiraContratacaoEmprestimo'),
          value: 'datPrimeiraContratacaoEmprestimo',
          align: 'center',
          component: DataTableDateOnlyColumn,
        },
        {
          text: this.$t('app.customers.list.headers.qtdContratacaoEmprestimo'),
          value: 'qtdContratacaoEmprestimo',
          align: 'center',
          component: DataTableNumberColumnVue,
        },
        {
          text: 'Configuração',
          value: 'id',
          component: CustomerEditProrrogacaoModalColumnVue,
        },
      ],
      requestClass: CustomerRequest,
      hideEdit: true,
    };
  },
};
</script>
